<template>
  <div id="table-category-of-customer" class="table-category-of-customer-container">
    <vs-table
      ref="tableGroups"
      noDataText="Nenhuma categoria disponível para selecionar"
      pagination
      multiple
      :max-items="itemsPerPage"
      search
      v-model="selectedGroups"
      :data="groups"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4"
        >
          <div
            class="
              p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg
              cursor-pointer flex items-center justify-between font-medium
            "
          >
            <span class="mr-2">
              {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                    groups.length - currentPage * itemsPerPage > 0
                    ? currentPage * itemsPerPage
                    : groups.length
              }} of {{ queriedItems }}
            </span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Nome</vs-th>
        <vs-th sort-key="name">Etiqueta</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-email font-medium truncate">{{ tr.group.name }}</p>
            </vs-td>
            <vs-td>
              <vs-icon icon="label" size="large" :color="tr.group.color_tag"></vs-icon>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-button 
      class="float-left" 
      @click="saveGroupsOnCustomer" 
      :disabled="!selectedGroups.length"
    >
      Selecionar Categoria
    </vs-button>
  </div>
</template>

<script>
  export default {
    name: 'table-category-of-customer',
    props: {
      groups: {
        type: Array,
        required: true
      },
      addGroupPopupActive: Boolean
    },
    data() {
      return {
        itemsPerPage: 4,
        isMounted: false,
        selectedGroups: []
      }
    },
    watch: {
      addGroupPopupActive: function () {
        this.selectedGroups = []
      }
    },
    computed: {
      currentPage() {
        if (this.isMounted) {
          return this.$refs.tableGroups.currentx
        }

        return 0
      },
      queriedItems() {
        return 0
      }
    },
    methods: {
      saveGroupsOnCustomer() {
        this.$emit('saveGroupsOnCustomer', this.selectedGroups)
      }
    },
    mounted() {
      this.isMounted = true
    }
  }
</script>

<style lang="scss">
  #table-category-of-customer {
    width: 100%;

    .vs-con-table {

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;


        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
